import script from "./NotificationsList.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsList.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsList.vue?vue&type=style&index=0&id=a42a2c7e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a42a2c7e"]])

export default __exports__